/* Load secondary product photos only on pointer or keyboard intent. */
(function () {
  'use strict';
  function hydrate(target) {
    if (!(target instanceof Element)) return;
    var card = target.closest('.product-item');
    var img = card && card.querySelector('img.product-item__secondary-image[data-cpis-secondary-src]');
    if (!img || img.dataset.cpisSecondaryLoaded === 'true') return;
    var source = img.getAttribute('data-cpis-secondary-src');
    if (!source) return;
    img.dataset.cpisSecondaryLoaded = 'true';
    var width = Math.max(200, Math.min(800, Math.ceil((img.getBoundingClientRect().width || 250) * (window.devicePixelRatio || 1) / 100) * 100));
    img.addEventListener('load', function () {
      img.classList.remove('cpis-secondary-deferred');
      img.classList.add('lazyloaded');
    }, {once: true});
    img.addEventListener('error', function () {
      delete img.dataset.cpisSecondaryLoaded;
      img.removeAttribute('src');
    }, {once: true});
    img.setAttribute('src', source.replace('{width}', String(width)));
  }
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch' || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    hydrate(event.target);
  }, {passive: true});
  document.addEventListener('focusin', function (event) { hydrate(event.target); });
})();